<template>
  <div class="view view--settings">
    <img src="/static/img/logo.svg" class="logo" alt="Logo hiitly">
    <csettings></csettings>
    <div class="action">
      <h2 class="totaltime">{{ sec2time(totalTime) }}m</h2>
      <h3 class="totaltime__sub">Total Workout Duration</h3>
      <span
        class="startbutton"
        @click="playBeep()">
          Start now!
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import csettings from '@/components/c_settings.vue';

export default {
  name: 'home',
  components: {
    csettings,
  },
  computed: {
    ...mapGetters([
      'settingsActive',
      'currentTimer',
    ]),
    totalTime() {
      const total = this.currentTimer.warmup
        + this.currentTimer.stretching
        + (this.currentTimer.intervals + this.currentTimer.breaks)
          * this.currentTimer.rounds * this.currentTimer.exercises
        + this.currentTimer.breaks; // after warmup
      return total;
    },
  },
  methods: {
    playBeep() {
      this.$emit('playBeep');
      this.$emit('makeAnnouncement', { prefix: 'let us:', title: 'start' });
      this.$router.push('/timer');
    },
  },
};
</script>
<style lang="stylus">
@import '~styles/variables.styl'

.action
  margin-top auto
  width 100%
  padding-bottom 3.0rem
.totaltime
  font-size 48px
  font-weight 500
  color white
.totaltime__sub
  text-transform uppercase
.startbutton
  background gelb(.9)
  display inline-block
  text-decoration none
  border none
  color dunkel
  font-family 'Fira Sans'
  font-weight 500
  font-size 30px
  padding .75rem 3rem
  margin-top 1rem
  border-radius 5px
  box-shadow 0 0 50px rgba(0,0,0,.3)
</style>
